import HTMLReactParser from "html-react-parser";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeTooltip, upgradeBuilding } from "../../../store/actions";

interface IProps {
  slot: any,
  gold: number,
  bricks: number,
  slotPrices: any
}

const mapDispatchToProps = (dispatch: any) => ({
  closeTooltip: () => dispatch(closeTooltip()),
  upgradeBuilding: (slotId: number, buildingTypeId: any) => dispatch(
    upgradeBuilding(slotId, buildingTypeId)
  )
})

const connector = connect(null, mapDispatchToProps);

const UpgradeBuilding = (props: IProps & ConnectedProps<typeof connector>) => (
  <>
    {props.slot.upgradeBuildings.map((slotUpgrade: any) => {
      const upgradeable = slotUpgrade.requirementsFulfilled
        && props.gold >= props.slotPrices[slotUpgrade.id].gold
        && props.bricks >= props.slotPrices[slotUpgrade.id].bricks;
      return (
        <>
          <h3 className="title text-left">{slotUpgrade.name}</h3>
          <p className="white">{HTMLReactParser(slotUpgrade.descriptionLong)}</p>
          {slotUpgrade.maintenance
            ? <p>-{slotUpgrade.maintenance} <i className="icon icon-standalone icon-zlato gold align-sub"/> per turn</p>
            : <></>
          }

          {slotUpgrade.requirementsFulfilled
            ? <>
              Cost:&nbsp;
              {props.slotPrices[slotUpgrade.id].gold}<i
              className="icon icon-standalone icon-zlato gold align-sub"/>&nbsp;
              {props.slotPrices[slotUpgrade.id].bricks}<i
              className="icon icon-standalone icon-infrastrukturni-body align-sub"/>&nbsp;
              {slotUpgrade.turns} Turns
            </>
            : <>
              Requires:<br />
              {slotUpgrade.prerequisities}
            </>}

          <div className="tooltip-footer">
            <a className="btn btn-blank btn-no-width no-margin-forced" onClick={props.closeTooltip}>Cancel</a>
            <a
               className={`btn btn-blank btn-no-width no-margin-forced ${!upgradeable ? "disabled" : ""}`}
               onClick={() => upgradeable && props.upgradeBuilding(props.slot.id, slotUpgrade.id)}
            >Upgrade</a>
          </div>
        </>
      )
    })}
  </>
)

export default connector(UpgradeBuilding);
